import {
  DocumentEsignStatuses,
  EsignVendors,
} from '../document-renewed/constants'

const SUCCESS_CODES = [200, 204]

const restBody = async (url, payload, method = 'POST') =>
  await fetch(url, {
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: sessionStorage.getItem('authToken') || null,
    },
    ...(payload ? { body: JSON.stringify(payload) } : {}),
  })

const getLoanAssistURL = () => {
  const url = new URL(window.location.href)

  url.searchParams.delete('envelopeId')
  url.searchParams.delete('event')

  return url.href
}

export const getTemplate = async (baseUrl, docTitle, onSuccess, onFailure) => {
  try {
    const result = await restBody(`${baseUrl}/template/search`, {
      parameters: {
        search_criteria: {
          document_name: docTitle,
        },
      },
    })

    const { data } = await result.json()

    if (!!data) {
      onSuccess(
        data?.attributes?.docusign_template_id,
        data?.attributes?.custom_fields,
        data?.attributes?.roles,
      )
    } else {
      onFailure()
    }
  } catch {
    onFailure()
  }
}

export const createEsignature = async (
  baseUrl,
  signers,
  templateId,
  customFields,
  loanId,
  upsertDocumentBucket,
  documentId,
  customFileInfo,
) => {
  let response = ''

  try {
    const result = await restBody(`${baseUrl}/esignature/`, {
      data: {
        type: 'e_signature',
        attributes: {
          signers: signers.map(({ name, email, source_id, source_type }) => ({
            name,
            email,
            source_id,
            source_type,
          })),
          template_id: templateId,
          custom_fields: customFields,
          source_type: 'Loan',
          source_id: loanId?.toString() || '',
          subject: 'Request for E-Signature',
          loan_assist_url: getLoanAssistURL(),
          documents: customFileInfo ? [customFileInfo] : [],
        },
      },
    })

    const { data } = await result.json()

    if (!!data) {
      const {
        id: esignatureId,
        attributes: { prepared_envelope_link: docuLink } = {},
      } = data

      if (docuLink && esignatureId) {
        await upsertDocumentBucket({
          variables: {
            input: {
              documentId: documentId || null,
              documentFields: {
                documentKey: esignatureId,
                esignStatus: DocumentEsignStatuses.draft,
                esignVendor: EsignVendors.DocuSign,
              },
            },
          },
        })

        response = docuLink
      }
    }
  } catch {}

  return response
}

export const sendReminder = async (
  baseUrl,
  documentKey,
  onSuccess,
  onFailure,
) => {
  try {
    const { status } = await restBody(
      `${baseUrl}/esignature/${documentKey}/send_reminder`,
    )

    if (SUCCESS_CODES.includes(status)) {
      onSuccess()
    } else {
      onFailure()
    }
  } catch {
    onFailure()
  }
}

export const cancelEsignature = async (
  baseUrl,
  documentKey,
  upsertDocumentBucket,
  onFailure,
) => {
  try {
    const { status } = await restBody(
      `${baseUrl}/esignature/${documentKey}/cancel`,
      {
        data: {
          type: 'e_signature',
          attributes: {
            status: DocumentEsignStatuses.voided,
          },
        },
      },
      'PATCH',
    )

    if (SUCCESS_CODES.includes(status)) {
      upsertDocumentBucket()
    } else {
      onFailure()
    }
  } catch {
    onFailure()
  }
}

export const prepareLink = async (
  baseUrl,
  documentKey,
  onSuccess,
  onFailure,
) => {
  try {
    const result = await restBody(
      `${baseUrl}/esignature/${documentKey}/prepared_envelope_link`,
      {
        data: {
          type: 'e_signature',
          attributes: {
            loan_assist_url: getLoanAssistURL(),
          },
        },
      },
    )

    const { data } = await result.json()

    if (!!data) {
      onSuccess(data?.attributes?.prepared_envelope_link)
    } else {
      onFailure()
    }
  } catch {
    onFailure()
  }
}

export const getSignersStatus = async (
  baseUrl,
  documentKey,
  onSuccess,
  onFailure,
) => {
  try {
    const result = await restBody(
      `${baseUrl}/esignature/${documentKey}/status`,
      null,
      'GET',
    )

    const { data } = await result.json()

    if (!!data) {
      onSuccess({ signers: data?.attributes?.signers || [] })
    } else {
      onFailure()
    }
  } catch {
    onFailure()
  }
}
